import React from 'react';
import BorrowerOnboardingSC from './investor-onboarding.styled';
import InfoBanner from '../../components/info-banner';
import ContentWrap from '../../components/content-wrap';
import InvestorOnboardingBanner from '../../components/investor-onboarding-banner';
import InvestorOnboardingContent from '../../components/investor-onboarding-content';

const InvestorOnboarding = () => {
  return (
    <BorrowerOnboardingSC>
      <InfoBanner>
        <InvestorOnboardingBanner />
      </InfoBanner>
      <ContentWrap>
        <InvestorOnboardingContent />
      </ContentWrap>
    </BorrowerOnboardingSC>
  );
};

export default InvestorOnboarding;
